import { defineComponent as _defineComponent } from 'vue'
import { useVersionStore } from '@/store/pinia/version'
import AppButton from '../ui/button/AppButton.vue'
import { ModalContent, ModalFooter, ModalHeader, ModalRoot } from '../ui/modal'


export default /*#__PURE__*/_defineComponent({
  __name: 'VersionChecker',
  setup(__props) {

const versionStore = useVersionStore()

return { __sfc: true,versionStore, AppButton, ModalContent, ModalFooter, ModalHeader, ModalRoot }
}

})